import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trusted-by',
  templateUrl: './trusted-by.component.html',
  styleUrls: ['./trusted-by.component.scss']
})
export class TrustedByComponent {

  @Input() trustedByHosptial;

  constructor() { }
}
